import { Routes } from '@angular/router';
import { NoContent, Forbidden } from './no-content';
import { AuthGuard } from './common/services';
import { LoginGuard } from './login/guard.service';

export const ROUTES: Routes = [
  { path: 'report', loadChildren: './report-share/report-share.module#ReportModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './layout/layout.module#LayoutModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: './login/login.module#LoginModule', canActivate: [LoginGuard] },
  { path: '403',    component: Forbidden },
  { path: '**',    component: NoContent },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/app.routes.ts